<template>
  <div id="app">
	<!-- progress bar	 -->
	<div v-if="fetching_data" class="progress fixed-top" style="height: 3px">
		<div class="progress-bar bg-success"
			role="progressbar"
			style="width: 0%; margin-left: 0%; animation: progress .5s infinite"
			aria-valuenow="75"
			aria-valuemin="50"
			aria-valuemax="100"></div>
	</div>
	<!-- main (side) navigation -->
	<nav>
		<div v-if="isAuthenticated" style="position: absolute;" class="navbar navbar-expand-lg navbar-light">
			<button class="btn btn-light" type="button" v-on:click="openNav()">
				<span class="navbar-toggler-icon"></span>
			</button>
		</div>
		<div id="side_nav" class="sidenav rounded shadow shadow-sm">
			<div class="ml-4">
				<img style="width: 40px; height: auto;" src="@/assets/logo.png" alt="">
				Vidduka
			</div>
			<!-- shop details -->
			<div class="mt-3 d-flex justify-content-between">
				<h4 class="ml-4 mr-2 d-flex flex-wrap font-weight-bold text-truncate"
					v-if="details">
					{{details.name}}
				</h4>
				<a href="javascript:void(0)" class="closebtn mr-5 text-dark" v-on:click="closeNav()">
					<h2 style="position:absolute; top:0">&times;</h2>
				</a>
			</div>
			<div class="ml-4 d-flex justify-content-start">
				<div class="d-flex">
					<span v-if="locations">{{logged_in_user_location_id | location(locations)}}</span>
				</div>
			</div>
			<hr class="">
			<!-- navigation items		 -->
			<div class="d-flex justify-content-right p-4">
				<ul class="list-unstyled text-left text-capitalize nav-list">
					<li class="d-none mt-3" :class="{ active : current_route_group == 'home'}" @click="goto('/on-boarding')">
						<i class="mr-2 fa fa-home" aria-hidden="true"></i>
						<span class="ml-3">on boarding</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'home'}" @click="goto('/')">
						<i class="mr-2 fa fa-home" aria-hidden="true"></i>
						<span class="ml-3">Home</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'pos'}" @click="goto('/pos')">
						<vue-fontawesome class="mr-2" icon="shopping-basket"></vue-fontawesome>
						<span class="ml-3" >POS</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'sales'}" @click="goto('/sales')">
						<vue-fontawesome class="mr-2" icon="shopping-bag"></vue-fontawesome>
						<span class="ml-3">sales</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'orders'}" @click="goto('/orders')">
						<vue-fontawesome class="mr-2" icon="cart-arrow-down"></vue-fontawesome>
						<span class="ml-3">orders</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'expenses'}" @click="goto('/expenses')">
						<vue-fontawesome class="mr-2" icon="calculator"></vue-fontawesome>
						<span class="ml-3">expenses</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'debtors'}" @click="goto('/debtors')">
						<vue-fontawesome class="mr-2" icon="credit-card"></vue-fontawesome>
						<span class="ml-3">debtors</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'purchases'}" @click="goto('/purchases')">
						<vue-fontawesome class="mr-2" icon="money"></vue-fontawesome>
						<span class="ml-3">purchases</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'products'}" @click="goto('/products')">
						<vue-fontawesome class="mr-2" icon="cubes"></vue-fontawesome>
						<span class="ml-3">products</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'stock'}" @click="goto('/stock')">
						<vue-fontawesome class="mr-2" icon="sort"></vue-fontawesome>
						<span class="ml-3">stock</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'customers'}" @click="goto('/customers')">
						<vue-fontawesome class="mr-2" icon="users"></vue-fontawesome>
						<span class="ml-3" to="/customers">customers</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'reports'}" @click="goto('/reports')">
						<vue-fontawesome class="mr-2" icon="bar-chart"></vue-fontawesome>
						<span class="ml-3">reports</span>
					</li>
					<hr>
					<li class="mt-3" :class="{ active : current_route_group == 'locations'}" @click="goto('/locations')">
						<vue-fontawesome class="mr-2" icon="map-marker"></vue-fontawesome>
						<span class="ml-3">Locations</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'unitsOfMeasure'}" @click="goto('/units-of-measure')">
						<vue-fontawesome class="mr-2" icon="balance-scale"></vue-fontawesome>
						<span class="ml-3">Units of measure</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'businessDetails'}" @click="goto('business-details')">
						<vue-fontawesome class="mr-2" icon="building-o"></vue-fontawesome>
						<span class="ml-3" to="/business-details">business details</span>
					</li>
					<hr>
					<li class="mt-3" :class="{ active : current_route_group == 'users'}" @click="goto('users')">
						<span class="ml-3" to="/users">system users</span>
					</li>
					<li class="mt-3" :class="{ active : current_route_group == 'billing'}" @click="goto('billing')">
						<span class="ml-3" to="/users">Billing</span>
					</li>
					<hr>
				</ul>
			</div>
		</div>
	</nav>

	<!-- top bar -->
	<div v-if="isAuthenticated">
		<!-- notification pill -->
		<div>
			<div id="alert-snackbar" class="snackbar bg-danger rounded">{{alert.message}}</div>
		</div>
		<div>
			<div id="success-snackbar" class="snackbar bg-success rounded">{{success.message}}</div>
		</div>
		<div class="d-flex justify-content-end">
			<!-- notification bell cash drawer-->
			<div class="d-flex justify-content-end mr-5 mt-1" >
				<!-- logged in user avatar-->
				<div class="p-1 rounded  shadow-sm bg-white dropleft" v-if="logged_in_user">
					<!-- cash register -->
					<button class="btn btn-lg btn-outline" @click="openDrawer()">
						<small>In cash drawer :</small>
						<small class="ml-2">{{drawer_running_amount}}</small>
					</button>
					<!-- notification bell -->
					|
					<button class="btn btn-lg btn-outline" @click="getMessagingToken();openNotifications()">
						<vue-fontawesome  icon="bell-o"></vue-fontawesome>
						<small v-if="notification_count > 0" class="text-danger">({{notification_count}})</small>
					</button>
				</div>
			</div>

				<!-- avatar -->
			<div class="d-flex justify-content-end mr-5 mt-1 rounded" >
				<!-- logged in user avatar-->
				<div class="p-1 d-flex rounded  shadow-sm bg-white" v-if="logged_in_user">
					<div class="cursor-pointer d-flex flex-column justify-content-center"
						@click="goto('/billing')">
						<small>Estimated costs: $0.00</small>
						<small>(You are on free trial now)</small>
					</div>
					<div class="p-3 d-flex flex-column justify-content-center">
						|
					</div>
					<button type="button"
							class="btn btn-lg btn-outline-success dropdown-toggle"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false">
						{{(logged_in_user.first_name).charAt(0)}}
					</button>
					<!-- after clicking avatar this appears -->
					<div class="dropdown-menu border-light shadow rounded" style="min-width:200px">
						<span class="p-4">
								{{logged_in_user.first_name}} {{logged_in_user.last_name}}
						</span>
						<span class="p-4">
								{{logged_in_user.phone_number}}
						</span>
						<div class="dropdown-divider"></div>
						<a class="dropdown-item"
							style="cursor:pointer"
							@click="logout">
							logout
						</a>
						<a class="dropdown-item"
							style="cursor:pointer"
							data-toggle="dropdown"
							aria-haspopup="true"
							aria-expanded="false">
							switch account
						</a>
						<!-- after clicking avatar this appears -->
						<div class="dropdown-menu border-light shadow rounded" style="min-width:200px">
							<div>
								<login inset=true inset_height="30vh"></login>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

	</div>
	<!-- aplication content -->
	<div id="main_app">
		<!-- TODO make margin left to zero on small devices -->
		<keep-alive include="pos,sales,orders,expenses,purchases,products,stock,reports,debtors">
			<router-view
				class="p-4"
				v-on:newLogin="newLogin"
				v-on:closeNav="closeNav"
				v-on:openNav="openNav"
				v-on:alert="showAlert"
				v-on:success="showSuccess"
			/>
		</keep-alive>
	</div>

	<!-- notification side div -->
	<div id="notification-div" class="side-notifications rounded shadow-lg">
		<div class="mt-5 shadow-sm p-2 d-flex justify-content-between">
			<h4>Notifications</h4>
			<button class="btn btn-light" type="button" v-on:click="closeNotifications()">
				<span class="navbar-toggler-icon">&times;</span>
			</button>
		</div>
		<div class="d-flex justify-content-center">
			<button class="btn btn-sm btn-outline-success border-0"
				@click="clearNotifications()">
				Clear all
			</button>
		</div>
		<!-- notifications list items-->
		<div class="p-2 d-flex flex-column" style="height: 70vh; overflow-y:scroll">
			<a href="#" v-for="(notification,index) in notifications" :key="index"
				class="mt-3 border-0 rounded shadow-sm rounded list-group-item list-group-item-action flex-column align-items-start">
				<div class="d-flex w-100 justify-content-between">
					<h5 class="mb-1">{{notification.data.title}}</h5>
					<small class="text-muted">{{notification.timeStamp | fromNow}}</small>
				</div>
				<p class="mb-1">{{notification.data.message}}</p>
			</a>
		</div>
	</div>

	<!-- cash drawer side div -->
	<div id="cashdrawer-div" class="side-notifications rounded shadow-lg">
		<div class="mt-2 shadow-sm p-2 d-flex justify-content-between">
			<h4>Cash Drawer activity</h4>
			<button class="btn btn-light" type="button" v-on:click="closeDrawer()">
				<span class="navbar-toggler-icon">&times;</span>
			</button>
		</div>
		<div class="d-flex justify-content-between px-3 mt-2 ">
			<small>starting balance</small>
			<input type="number" class="form-control w-50" name="" v-model="starting_balance">
		</div>
		<div class="d-flex justify-content-between px-3 mt-2">
			<small>running balance</small>
			<span>{{drawer_running_amount}}</span>
		</div>
		<div class="p-2 mt-3 d-flex justify-content-between">
			<button class="btn btn-outline-success"  v-on:click="setMode('in')">
				<vue-fontawesome class="mr-2" icon="arrow-down"></vue-fontawesome>
				Cash in
			</button>
			<button class="btn btn-outline-danger" v-on:click="setMode('out')">
				<vue-fontawesome class="mr-2" icon="arrow-up"></vue-fontawesome>
				Cash Out
			</button>
		</div>
		<!-- cash drawer input -->
		<div v-if="mode !== 'neutral'" class="p-4">
			<label >Amount</label>
			<input type="number" class="form-control" v-model="amount">
			<label class="mt-3">description</label>
			<input type="text" class="form-control" v-model="description">
			<div class="mt-4 d-flex justify-content-between">
				<button v-if="mode === 'out'" class="btn btn-outline-danger" v-on:click="recordCashOut()">
					<vue-fontawesome class="mr-2" icon="arrow-up"></vue-fontawesome>
					Cash out
				</button>
				<button v-if="mode === 'in'" class="btn btn-outline-success" v-on:click="recordCashIn()">
					<vue-fontawesome class="mr-2" icon="arrow-down"></vue-fontawesome>
					Cash in
				</button>
				<button class="btn btn-outline-secondary" v-on:click="setMode('neutral')">
					Cancel
				</button>
			</div>
		</div>
		<!-- notifications list items-->
		<div v-if="mode === 'neutral'" class="p-2 d-flex flex-column" style="height: 70vh; overflow-y:scroll">
			<a href="#" v-for="(activity,index) in activities" :key="index"
				class="mt-3 border-0 rounded shadow-sm rounded list-group-item list-group-item-action flex-column align-items-start">
				<div class="d-flex w-100 justify-content-between">
					<h5 class="mb-1">
						<vue-fontawesome class="text-danger mr-2" icon="arrow-up" v-if="activity.status === 'out'"></vue-fontawesome>
						<vue-fontawesome class="text-success mr-2" icon="arrow-down" v-if="activity.status === 'in'"></vue-fontawesome>
					</h5>
					<small class="text-muted">{{activity.amount}}</small>
				</div>
				<p class="mb-1">{{activity.description}}</p>
			</a>
		</div>
		<div class="mt-2 d-flex justify-content-center">
			<button class="btn btn-sm btn-outline-success border-0">
				Clear all
			</button>
		</div>
	</div>
  </div>
</template>

<script>
	import store from './store'
	import router from "./router"
	//mixins
	import update from './mixins/updates'
	import registerForNotifications from './mixins/appDotVue/registerForNotifications.js'
	import showNotifications from './mixins/appDotVue/showNotifications.js'
	import cashdrawer from './mixins/appDotVue/cashdrawer.js'
	//components.
	import login from './views/auth/login.vue'
	export default {
	name: 'App',
	mixins: [update, registerForNotifications, showNotifications, cashdrawer],
	components:{login},
	data () {
		return{
			//logged in user data.
			isAuthenticated: false,
			locations:null,
			details:null,
		}
	},
	computed: {
		account_switched(){
			return this.$store.state.account_switch_count
		},
		new_sale(){
			return this.$store.state.new_sale_count
		},
		fetching_data(){
			return this.$store.state.fetching_data
		},
		logged_in_user(){
			return this.$store.state.logged_in_user
		},
		logged_in_user_location_id(){
			return this.$store.state.logged_in_user_location_id
		},
		current_route_group(){
			return this.$route.meta.group
		}
	},
	watch:{
		account_switched: function(){
			this.checkIsAuthenticated()
			if (screen.width < 760){
				this.openNav()
			}
		},
		updateExits: function(){
			if (this.updateExits){
				this.showSuccess("UPDATE was found, your app will refresh in a few seconds")
				setTimeout(()=>{
					this.refreshApp()
				},5000)
			}
		},
		isAuthenticated:function(){
			if(this.isAuthenticated){
				this.openNav()
			}
			else{
				this.closeNav()
			}
		},
	},
	mounted(){
		this.checkIsAuthenticated()
		if (screen.width < 760){
			this.openNav()
		}
	},
	methods: {
		clearNotifications: function(){
			localStorage.removeItem('notifications')
			store.commit('clear_notifications')
		},
		/* Set the width of the side navigation to 250px */
		openNav:function() {
			var main_app = document.getElementById('main_app')
			var side_nav = document.getElementById("side_nav")
			side_nav.style.width = "265px"
			if (screen.width > 760){
				main_app.style.marginLeft = "265px"
			}

		},
		/* Set the width of the side navigation to 0 */
		closeNav:function() {
			var main_app = document.getElementById('main_app')
			var side_nav = document.getElementById("side_nav")
			side_nav.style.width = "0"
			main_app.style.marginLeft = "0px"
		},
		closeNavOnMobile:function(){
			if (screen.width < 760){
				this.closeNav()
			}
		},
		//check that authentication details exist:
		checkIsAuthenticated:function(){
			if ("auth_token" in localStorage) {
				this.isAuthenticated = true
				this.getLocations()
				this.getDetails()
				return true
			} else {
				this.isAuthenticated =	false
				router.push("/login")
				return false
			}
		},
		// a new login has been successful
		newLogin:function(){
			this.isAuthenticated = true
			this.getLocations()
			this.getDetails()
			this.$router.push('/')
			this.openNav()
		},
		// logout
		logout: function(){
			this.isAuthenticated = false
			this.closeNav()
			localStorage.removeItem('auth_token')
			localStorage.removeItem('logged_in_user')
			localStorage.removeItem('logged_in_user_location_id')
			this.$router.push("/login")
		},
		goto: function(route_name){
			this.closeNavOnMobile()
			this.$router.push(route_name)
		},
		//get locations.
		getLocations: function(){
			this.$http({
				method:'get',
				url: this.$API_BASE_URL + `/HJYBCFRB/${this.$version}/locations/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},
			}).then((response)=>{
				this.locations = response.data
			}).catch((err)=>{
				this.$emit('alert',err)
			})
		},
		//get business details
		getDetails: function(){
			this.$http({
				method:'get',
				url: this.$API_BASE_URL + `/HJYBCFRB/business-details/`,
				headers:{
					Authorization: JSON.parse(localStorage.getItem('auth_token'))
				},
			}).then((response)=>{
				this.details = response.data
				localStorage.setItem("business_details",JSON.stringify(this.details))
				//listen for notification token refresh.
				this.getMessagingToken()
				this.listenTokenRefresh()
			}).catch((err)=>{
				this.$emit('alert',err)
			})
		},
	}
}
</script>

<style lang="scss">
@import './assets/styles/app_skeleton.scss';
</style>
